module.exports = __webpack_public_path__ + "static/media/team-image-1.f259021e.webp";